// extracted by mini-css-extract-plugin
module.exports = {"projectBox":"ProjectBoxVertical-module--projectBox--1W9Wg","data":"ProjectBoxVertical-module--data--3gwT0"};